import { PropsWithChildren, ReactNode, useCallback, useState } from 'react'
import { ModalFooter, ModalTitle, ModalWrapper, WarningTip } from './atom'
import { Button, ModalProps } from 'task-eva-ui'
import CloseIcon from 'task-eva-ui/assets/svg/modal-close'
import { getTranslateNsT } from '@/utils/get-translate-nst'
import { RenderModalSize } from './constants'
import { getRenderModalSize } from './utils'
import WarningIcon from 'task-eva-ui/assets/svg/modal-warning'
import { ThemeTypeList } from 'task-eva-ui/constants'
import LoadingIcon from 'task-eva-ui/assets/svg/loading'

export function RenderModal({
  children,
  title = '',
  renderModalSize = 'middle',
  warningTip,
  showWarningIcon,
  warningIcon,
  onClose,
  onOk,
  submitting,
  confirmDisable,
  cancelText,
  confirmText,
  className = '',
  haveCancel = true,
  haveConfirm = true,
  center,
}: RenderModalProps) {
  const commonT = getTranslateNsT('common')
  const [loading, setLoading] = useState(submitting ?? false)

  const onOKHandle = useCallback(async () => {
    setLoading(true)
    if (onOk) {
      await onOk()
    }
    setLoading(false)
  }, [onOk])

  const onCloseHandle = useCallback(async () => {
    if (onClose) {
      await onClose()
    }
    setLoading(false)
  }, [onClose])
  return (
    <ModalWrapper
      className={`common-modal-wrapper ${className}`}
      css={getRenderModalSize(renderModalSize)}
    >
      <ModalTitle className='render-modal-title'>
        {title}
        <CloseIcon onClick={() => void onCloseHandle()} />
      </ModalTitle>
      {warningTip && (
        <WarningTip>
          {warningIcon ? warningIcon : showWarningIcon ? <WarningIcon /> : null}
          {warningTip}
        </WarningTip>
      )}
      {center ? <div className='render-modal-content'>{children}</div> : children}
      <ModalFooter gap={12} center className='common-modal-footer'>
        {haveCancel && (
          <Button
            themeType={ThemeTypeList.USER_CENTER}
            default
            onClick={() => void onCloseHandle()}
          >
            {cancelText || commonT('common_cancel')}
          </Button>
        )}
        {haveConfirm && (
          <Button
            themeType={ThemeTypeList.USER_CENTER}
            disabled={loading || confirmDisable}
            className='confirm-button'
            onClick={() => void onOKHandle()} // Fix: Explicitly return void when calling onOKHandle
          >
            {confirmText || commonT('common_confirm')}
            {loading && <LoadingIcon />}
          </Button>
        )}
      </ModalFooter>
    </ModalWrapper>
  )
}
export type RenderModalSizeType = `${RenderModalSize}`
export type RenderModalProps = PropsWithChildren<
  ModalProps & {
    renderModalSize?: RenderModalSizeType
    warningTip?: ReactNode
    showWarningIcon?: boolean
    warningIcon?: ReactNode
    sumbmitTasklist?: number[]
    className?: string
    msg?: string
    haveCancel?: boolean
    haveConfirm?: boolean
    center?: boolean
  }
>
